export default __webpack_public_path__ + "static/media/DatatwinIcon.b2910d0d.png";